module.exports = __webpack_public_path__ + "img/Duration.80ada7fc.svg";